export default __webpack_public_path__ + "static/mail-illustration-231cc7d0ae53dc7d32a60f5ff7b17de2.png";